import { VarBacktestApiResponse } from '../../queries';

export interface IFundSharePrice {
  name: string | number;
  price: number;
}

export function buildFundSharePrice(
  data: VarBacktestApiResponse[],
): IFundSharePrice[] {
  const output = data[0].cis_time_series.map((data: (string | number)[]) => {
    return {
      name: data[0],
      price: typeof data[1] === 'number' ? data[1] : Number(data[1]),
    };
  });
  output.shift();
  return output;
}
